import { getCalApi } from '@calcom/embed-react';

export const FOUNDER_CALL_URL = 'https://cal.com/uselima/20min';

const CAL_NAMESPACE = '20min';
const CAL_LINK = 'uselima/20min';
const CAL_CONFIG = { layout: 'month_view', useSlotsViewOnSmallScreen: 'true', theme: 'light' } as const;

// Loads Cal.com's embed script; call early so the popup opens instantly.
export const loadFounderCallEmbed = async () => {
  const cal = await getCalApi({ namespace: CAL_NAMESPACE });
  cal('ui', {
    hideEventTypeDetails: false,
    layout: 'month_view',
    theme: 'light',
    // Lima palette (see :root in lima-staging.css).
    cssVarsPerTheme: {
      light: {
        'cal-brand': '#0f0d0a',
        'cal-brand-emphasis': '#57514a',
        'cal-brand-text': '#ffffff',
        'cal-text': '#0f0d0a',
        'cal-text-emphasis': '#0f0d0a',
        'cal-text-subtle': '#797473',
        'cal-text-muted': '#797473',
        'cal-bg': '#ffffff',
        'cal-bg-muted': '#f1f0ef',
        'cal-bg-subtle': '#f1f0ef',
        'cal-bg-emphasis': '#e0ddda',
        'cal-border': '#e0ddda',
        'cal-border-subtle': '#e0ddda',
      },
      dark: {},
    },
  });
  return cal;
};

export const openFounderCall = async () => {
  try {
    const cal = await loadFounderCallEmbed();
    cal('modal', { calLink: CAL_LINK, config: CAL_CONFIG });
  } catch {
    // Embed blocked or offline: fall back to the booking page.
    window.open(FOUNDER_CALL_URL, '_blank', 'noopener,noreferrer');
  }
};

// Dismissal is per workspace and per browser.
const dismissedKey = (workspaceId: string) => `lima_founder_call_dismissed:${workspaceId}`;

export const isFounderCallDismissed = (workspaceId: string | undefined) => {
  if (!workspaceId) return false;
  try {
    return localStorage.getItem(dismissedKey(workspaceId)) === '1';
  } catch {
    return false;
  }
};

export const dismissFounderCall = (workspaceId: string | undefined) => {
  if (!workspaceId) return;
  try {
    localStorage.setItem(dismissedKey(workspaceId), '1');
  } catch {
    // Storage unavailable; dismissal lasts until the next reload.
  }
};
